import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button/button.component';
import { ButtonGroupComponent } from './button-group/button-group.component';
import { ButtonIconComponent } from './button-icon/button-icon.component';
import { FontAwesomeConfigModule } from 'src/app/font-awesome-config.module';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeConfigModule
  ],
  declarations: [
    ButtonComponent,
    ButtonGroupComponent,
    ButtonIconComponent
  ],
  exports: [
    ButtonComponent,
    ButtonGroupComponent,
    ButtonIconComponent
  ]
})
export class ButtonsModule { }
